import styles from './CourseFilter.module.css'
import { useEffect, useState } from 'react';

function CourseFilter({ onFilter }) {
    const [category, setCategory] = useState('all');
    const [level, setLevel] = useState('all');
    const [search, setSearch] = useState('');

    const handleChange = (newCategory, newLevel, newSearch) => {
        onFilter(newCategory, newLevel, newSearch);
    };

    return (
        <div className={styles.filterSection}>
            <div className="row g-3">
                <div className="col-md-4">
                    <select
                        value={category}
                        className={`${styles.formSelect} form-select`}
                        onChange={(e) => {
                            setCategory(e.target.value);
                            handleChange(e.target.value, level, search);
                        }}
                    >
                        <option value="all">All Categories</option>
                        <option value="Frontend">Frontend</option>
                        <option value="Backend">Backend</option>
                        <option value="Data Science">Data Science</option>
                        <option value="Business">Business</option>
                    </select>
                </div>
                <div className="col-md-4">
                    <select
                        value={level}
                        className={`${styles.formSelect} form-select`}
                        onChange={(e) => {
                            setLevel(e.target.value);
                            handleChange(category, e.target.value, search);
                        }}
                    >
                        <option value="all">All Levels</option>
                        <option value="Beginner">Beginner</option>
                        <option value="Intermediate">Intermediate</option>
                        <option value="Advanced">Advanced</option>
                    </select>
                </div>
                <div className="col-md-4">
                    <input
                        type="text"
                        value={search}
                        className={`${styles.formControl} form-control`}
                        placeholder="Search courses..."
                        onChange={(e) => {
                            setSearch(e.target.value);
                            handleChange(category, level, e.target.value);
                        }}
                    />
                </div>
            </div>
        </div>
    );
}

export default CourseFilter